import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MarkdownModule } from 'ngx-markdown';
import { HelpHomeComponent } from './help-home.component';
import { HelpCollectionComponent } from './help-collection.component';
import { HelpArticleComponent } from './help-article.component';
import { HelpSearchComponent } from './help-search.component';

/**
 * Shared, navigation-agnostic help-center UI used by the standalone help app, the in-portal /help route,
 * and the in-portal help drawer. Consumers must have called `MarkdownModule.forRoot()` at app root and
 * must provide the `'environment'` token (for `HelpService`'s api_prefix).
 */
@NgModule({
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule, MarkdownModule],
  declarations: [HelpHomeComponent, HelpCollectionComponent, HelpArticleComponent, HelpSearchComponent],
  exports: [HelpHomeComponent, HelpCollectionComponent, HelpArticleComponent, HelpSearchComponent],
})
export class HelpModule {}
